(() => {
  "use strict";

  const currencyDigits = (locale, currency) => new Intl.NumberFormat(
    locale || "en-CA",
    { style: "currency", currency: currency || "CAD" }
  ).resolvedOptions().maximumFractionDigits;

  const toMinor = (major, currency, locale) => Math.round(
    Number(major || 0) * (10 ** currencyDigits(locale, currency))
  );

  const formatMoney = (minor, currency, locale) => new Intl.NumberFormat(
    locale || "en-CA",
    { style: "currency", currency: currency || "CAD" }
  ).format(Number(minor || 0) / (10 ** currencyDigits(locale, currency)));

  function getOffer(country, settings = {}) {
    if (country === "CA") {
      return {
        cents: Number(settings.canadaThresholdCents || 10000),
        currency: settings.canadaThresholdCurrency || "CAD",
        region: "Canada"
      };
    }
    if (country === "US") {
      return {
        cents: Number(settings.usThresholdCents || 15000),
        currency: settings.usThresholdCurrency || "USD",
        region: "US"
      };
    }
    return {
      cents: Number(settings.worldThresholdCents || 20000),
      currency: settings.worldThresholdCurrency || "CAD",
      region: "Worldwide"
    };
  }

  function getThresholdMinor(offer, cartCurrency, shopCurrency, rate, locale) {
    const targetMajor = offer.cents / 100;
    if (offer.currency === cartCurrency) return toMinor(targetMajor, cartCurrency, locale);

    const exchangeRate = Number(rate);
    if (!Number.isFinite(exchangeRate) || exchangeRate <= 0) return null;
    if (offer.currency === shopCurrency) {
      return toMinor(targetMajor * exchangeRate, cartCurrency, locale);
    }
    if (cartCurrency === shopCurrency && exchangeRate !== 1) {
      return toMinor(targetMajor / exchangeRate, cartCurrency, locale);
    }
    return null;
  }

  function calculate(subtotalMinor, thresholdMinor) {
    const subtotal = Number(subtotalMinor);
    const threshold = Number(thresholdMinor);
    if (!Number.isFinite(subtotal) || !Number.isFinite(threshold) || threshold <= 0) return null;
    const remaining = Math.max(0, threshold - subtotal);
    return {
      remaining,
      percent: Math.min(100, Math.round((subtotal / threshold) * 100)),
      unlocked: remaining === 0
    };
  }

  window.JazzisCartShippingProgress = Object.freeze({ getOffer, getThresholdMinor, calculate, formatMoney });
})();
